import Nav from './Nav';
import personImage from '../media/personDesktop.png';
import shapeImage from '../media/Rectangle.png';
import gridImage from '../media/cuadricula.png';
import facebookIcon from '../media/iconFacebookWithe.png';
import twitterIcon from '../media/iconTwitterWithe.png';
import instagramIcon from '../media/iconInstagramWithe.png';

const slides = [
  {
    id: 'tecnologia',
    title: 'Tecnología & Outsourcing',
    subtitle: 'Expertos en soluciones TIC para empresas',
    description:
      'Contamos con 10 años en el mercado ofreciendo soluciones tecnológicas para PYME de diversos sectores: turismo, telecomunicaciones, retail y viajes, entre otros.',
  },
  {
    id: 'marketing',
    title: 'Marketing digital',
    subtitle: 'Armamos una estrategia para potenciar tu marca',
    description:
      'Impulsamos tu producto o servicio con estrategias de marketing online orientadas a la captación de consumidores.',
  },
  {
    id: 'desarrollo',
    title: 'Desarrollo',
    subtitle: 'Sitios web, apps móviles y software a la medida',
    description:
      'Nuestros desarrollos son escalables, robustos y fáciles de usar. Trabajamos solo con las principales tecnologías, de acuerdo a las necesidades de cada proyecto.',
  },
];

const socialLinks = [
  {
    id: 'facebook',
    label: 'Facebook de Axioma Network',
    url: 'https://www.facebook.com/Axioma.Network/',
    icon: facebookIcon,
  },
  {
    id: 'twitter',
    label: 'Twitter de Axioma Network',
    url: 'https://mobile.twitter.com/axiomanetworkmx',
    icon: twitterIcon,
  },
  {
    id: 'instagram',
    label: 'Instagram de Axioma Network',
    url: 'https://www.instagram.com/Axioma.Network/',
    icon: instagramIcon,
  },
];

/**
 * Portada del home: navegación, carrusel de mensajes y redes sociales.
 *
 * El carrusel avanza solo con una animación CSS (@keyframes slide en
 * slider.scss), no con JavaScript. Si agregas o quitas una diapositiva hay que
 * ajustar los porcentajes de esa animación, porque están calculados para tres.
 */
const Slider = () => (
  <div className="slider">
    <div className="sliderNavbar">
      <div className="sliderLogo" role="img" aria-label="Axioma Network" />
      <Nav />
    </div>

    <div className="sliderContainer">
      <ul className="sliderSlides">
        {slides.map(({ id, title, subtitle, description }) => (
          <li className="sliderSlide" key={id}>
            <h3 className="sliderTitle">{title}</h3>
            <p className="textBold sliderSubtitle">{subtitle}</p>
            <p className="textContent sliderText">{description}</p>
          </li>
        ))}
      </ul>
    </div>

    <div className="sliderPerson">
      <img src={personImage} alt="" />
    </div>

    <div className="sliderSocial">
      {socialLinks.map(({ id, label, url, icon }) => (
        <a key={id} href={url} target="_blank" rel="noopener noreferrer" aria-label={label}>
          <div className="sliderSocialIcon">
            <img src={icon} alt="" />
          </div>
        </a>
      ))}
    </div>

    <div className="sliderGrid">
      <img src={gridImage} alt="" />
    </div>
    <div className="sliderShape">
      <img src={shapeImage} alt="" />
    </div>
  </div>
);

export default Slider;
